<template>
  <section class="engine-core">
    <img src="../../../../assets/img/yh.png" alt="" />
  </section>
</template>

<style lang="less" scoped>
.engine-core {
  position: relative;
  height: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.engine-core img {
  width: 96%;
  max-width: 1100px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 20px rgba(39, 255, 232, 0.28));
}
</style>
